import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';

@Pipe({ name: 'vesselRateDisplayNamePipe' })
export class VesselRateDisplayNamePipe implements PipeTransform {
  constructor(private titleCasePipe: TitleCasePipe) {}
  transform(rate: VesselRate): string {
    let returnValue = '';
    if (rate.rateType.includes('Custom')) {
      returnValue = this.titleCasePipe.transform(rate.name);
    } else if (rate.name === 'Fuel Included') {
      returnValue = 'Prepaid Fuel';
    } else {
      returnValue = this.titleCasePipe.transform(rate.rateType);
    }
    return returnValue;
  }
}
